<template>
  <t-form labelWidth="100px">

    <e-collapse title="基础属性" :expand="true">
      <t-form-item label="字体大小">
        <t-input-number :min="12" :max="200" v-model="attribute.fontSize" size="small" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="选中字体大小">
        <t-input-number :min="0" :max="200" v-model="attribute.activeFontSize" size="small" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="字体">
        <t-select v-model="attribute.textFamily" size="small">
          <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value" />
        </t-select>
      </t-form-item>
      <t-form-item label="选中字体">
        <t-select v-model="attribute.activeTextFamily" clearable size="small">
          <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value" />
        </t-select>
      </t-form-item>
      <t-form-item label="字体颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.textColor" size="small" />
      </t-form-item>
      <t-form-item label="选中字体色">
        <div class="tab-option-color-wrap">
          <div class="tab-option-select">
            <t-radio-group v-model="attribute.enableGradual" size="small">
              <t-radio-button :value="1">关闭</t-radio-button>
              <t-radio-button :value="2">渐变[从左到右]</t-radio-button>
              <t-radio-button :value="3">渐变[从上到下]</t-radio-button>
            </t-radio-group>
          </div>
          <template v-if="attribute.enableGradual == 1">
            <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.activeColor"
              enableAlpha />
          </template>
          <template v-else>
            <EColorGroup v-model="attribute.gradualColor" :min="2" :absolute="true" />
          </template>
        </div>
      </t-form-item>
      <t-form-item label="背景色">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.backgroundColor"
          enableAlpha />
      </t-form-item>
      <t-form-item label="区块背景色">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.itemBackgroundColor"
          enableAlpha />
      </t-form-item>
      <t-form-item label="选中背景色">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.activeBg"
          enableAlpha />
      </t-form-item>
      <t-form-item label="加粗">
        <t-radio-group v-model="attribute.fontWeight" size="small">
          <t-radio-button value="lighter">更细</t-radio-button>
          <t-radio-button value="normal">正常</t-radio-button>
          <t-radio-button value="bold">加粗</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="字体方向Y轴">
        <e-chart-position v-model="attribute.textPositionY" direction="y" />
      </t-form-item>
      <t-form-item label="字体方向X轴">
        <!-- <t-input-number :min="10" :max="1024" v-model="attribute.lineHeight" size="small" :decimal-places="0" /> -->
        <e-chart-position v-model="attribute.textPositionX" direction="x" />
      </t-form-item>

    </e-collapse>
    <e-collapse title="触发" :expand="true">
      <t-form-item label="默认选项">
        <t-select v-model="attribute.tabDefaultKey" size="small">
          <t-option v-for="item in tabList" :key="item.value" :label="item.label" :value="item.value" />
        </t-select>
      </t-form-item>
      <t-form-item label="默认选项URL参数">

        <t-input v-model="attribute.tabDefaultURLKey" autocomplete="off" />
      </t-form-item>

      <t-form-item label="悬浮">
        <t-switch v-model="attribute.isFiexd" size="small" :label="['开', '关']" />
      </t-form-item>
      <t-form-item label="悬浮位置" v-if="attribute.isFiexd">
        <t-select v-model="attribute.position" size="small">
          <t-option label="任意位置" value="all" />
          <t-option label="顶部" value="top" />
          <t-option label="底部" value="bottom" />
        </t-select>
      </t-form-item>
      <t-form-item label="悬浮X轴" v-if="attribute.isFiexd">
        <t-input-number size="small" v-model="attribute.postitionX" :min="0" :max="999999" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="悬浮Y轴" v-if="attribute.isFiexd">
        <t-input-number size="small" v-model="attribute.postitionY" :min="0" :max="999999" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="横向滚动条">
        <t-switch v-model="attribute.isScroll" size="small" :label="['开', '关']" />
      </t-form-item>
      <t-form-item label="设置单元格宽度" v-if="attribute.isScroll">
        <t-input-number :min="1" :max="10000" v-model="attribute.itemWidth" size="small" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="自动切换">
        <t-switch v-model="attribute.autoSwitch" size="small" :label="['开', '关']" />
      </t-form-item>
      <t-form-item label="切换置顶">
        <t-switch v-model="attribute.switchTop" size="small" :label="['开', '关']" />
      </t-form-item>
      <t-form-item label="动态高度">
        <t-switch v-model="attribute.autoHeight" size="small" :label="['开', '关']" />
      </t-form-item>
      <t-form-item label="切换间隔(s)" v-show="attribute.autoSwitch">
        <t-input-number :min="1" :max="100" v-model="attribute.interval" size="small" :decimal-places="0" />
      </t-form-item>

    </e-collapse>

    <e-collapse title="模版样式" :expand="true">
      <t-form-item label="布局方式">
        <t-select size="small" v-model="attribute.direction" @change="onChangeDirection">
          <t-option label="横向" value="row" />
          <t-option label="纵向" value="column" />
        </t-select>
      </t-form-item>
      <t-form-item label="选择模版">
        <t-button size="small" @click="onActionModal">{{ templateText }}</t-button>
      </t-form-item>
      <t-form-item label="模板JSON" v-if="isSelectTempJsonComputed">
        <t-button size="small" @click="onActionJsonModal">{{ templateText }}-JSON</t-button>
      </t-form-item>
      <t-form-item label="开启排版布局">
        <t-switch v-model="attribute.isOpenLayout" size="small" :label="['开', '关']" />
      </t-form-item>
      <!-- 排版布局开启 -->
      <template v-if="attribute.isOpenLayout">
        <!-- 横向 -->
        <template v-if="attribute.direction === 'row'">
          <t-form-item label="向左侧排版">
            <t-input-number :min="0" :max="1111" v-model="attribute.rowLeftNumber" size="small" :decimal-places="0" />
          </t-form-item>
          <t-form-item label="宽度">
            <t-input-number :min="0" :max="999999" v-model="attribute.rowItemWidth" size="small" :decimal-places="0" />
          </t-form-item>
          <t-form-item label="向左偏移量">
            <t-input-number :min="0" :max="999999" v-model="attribute.rowMarginLeft" size="small" :decimal-places="0" />
          </t-form-item>
          <t-form-item label="向右偏移量">
            <t-input-number :min="0" :max="999999" v-model="attribute.rowMarginRight" size="small"
              :decimal-places="0" />
          </t-form-item>
        </template>
        <!-- 纵向 -->
        <template v-else-if="attribute.direction === 'column'">
          <t-form-item label="顶部排版">
            <t-input-number :min="0" :max="1111" v-model="attribute.columnTopNumber" size="small" :decimal-places="0" />
          </t-form-item>
          <t-form-item label="高度">
            <t-input-number :min="0" :max="999999" v-model="attribute.columnItemHeight" size="small"
              :decimal-places="0" />
          </t-form-item>
          <!-- <t-form-item label="向上偏移量">
            <t-input-number :min="0" :max="999999" v-model="attribute.rowMarginTop" size="small" :decimal-places="0" />
          </t-form-item>
          <t-form-item label="向下偏移量">
            <t-input-number :min="0" :max="999999" v-model="attribute.rowMarginBottom" size="small" :decimal-places="0" />
          </t-form-item> -->
        </template>

      </template>



    </e-collapse>
    <e-collapse title="单选模板" v-if="templateRadioComputed" :expand="true">
      <t-form-item label="尺寸">
        <t-input-number :min="0" :max="999999" v-model="attribute.templateRadioSize" size="small" :decimal-places="0" />
      </t-form-item>
    </e-collapse>

    <t-dialog header="模板JSON" v-model:visible="templateJSONShow" :onConfirm="onJSONConfirm" :closeOnOverlayClick="false"
      width="800px" confirmBtn="刷新数据" :draggable="true">
      <b-ace-editor v-model="jsonText" theme="vibrant_ink" lang="json" ref="jsonEditor" :readonly="false"
        :styles="{ border: 'none' }" />
    </t-dialog>

    <t-dialog class="cpt-tab-option-dialog" header="选项卡模版样式" v-model:visible="modalShow" width="75%"
      :closeOnOverlayClick="false" top="50px" @confirm="confirmCheck" @cancel="onCancel">
      <div class="list">
        <div :class="{ 'list-item': true, 'active': tabStyleIndex == index }"
          v-for="(item, index) in tabStyleListComputed" :key="index" @click="onSelectStyle(index)">
          <t-image-viewer :images="[item.coverImg]">
            <template #trigger="{ open }">
              <div class="tdesign-demo-image-viewer__ui-image">
                <div class="cover-img">
                  <img :src="item.coverImg" alt="">
                </div>
                <div class="tdesign-demo-image-viewer__ui-image--hover" @click="open">
                  <span>
                    <BrowseIcon size="1.4em" /> 预览
                  </span>
                </div>
              </div>
            </template>
          </t-image-viewer>

          <p>{{ item.title }}</p>
        </div>
      </div>
      <t-pagination :total="tabStyleList.length" :showPageSize="false" v-model="currentPage" @change="onChangePage"
        v-model:pageSize="pageSize" />
    </t-dialog>



  </t-form>
</template>

<script>
import { BrowseIcon } from 'tdesign-icons-vue-next';
import EChartPosition from "@/components/designer/e-chart-position";
import { useCombinationTabStore } from '@/stores/combinationTabStore'
import { reactive, ref, onMounted, computed, watch } from 'vue'
import cptTabOption from '@/components/element/attrs/cpt-tab-option'
import EColorGroup from "@/components/designer/e-color-group.vue";
export default {
  name: "cpt-tab-option",
  props: { attribute: Object, currentCpt: Object, cptDataForm: Object, cacheComponents: Array, refMap: Object, },
  components: { BrowseIcon, EColorGroup, EChartPosition },
  setup(props) {
    const store = useCombinationTabStore()
    // let tabList = reactive([])
    let modalShow = ref(false)
    let tabStyleList = reactive(store.tabStyleList)
    let currentPage = ref(1)
    let pageSize = ref(15)
    let templateJSONShow = ref(false)
    let jsonEditor = ref(null)
    let jsonText = ref('')
    let textFamilyList = ref(require('@/assets/font/font-list'))
    const tabStyleIndex = ref(null)

    watch(() => props.attribute.isOpenLayout, value => {
      if (!value) {
        props.attribute.rowLeftNumber = 0
        props.attribute.rowItemWidth = 'unset'
        props.attribute.rowMarginLeft = 0
        props.attribute.rowMarginRight = 0
      }
    })

    //单选模板
    const templateRadioComputed = computed(() => {
      return props.attribute['tabStyleIndex'] == 2 && tabStyleList[props.attribute?.tabStyleIndex]?.setTabStyle == 'radio'
    })
    // 是否选择了模板
    const isSelectTempJsonComputed = computed(() => {
      return typeof props.attribute.tabStyleIndex === 'number'
    })
    // 模板标题
    const templateText = computed(() => {
      let isIndex = typeof props.attribute.tabStyleIndex === 'number'
      console.log(isIndex, 'isIndexisIndex')
      if (!isIndex) {
        return '添加模版'
      }
      let index = props.attribute.tabStyleIndex
      let list = tabStyleList
      return list[index]?.title
    })
    // 模板列表
    const tabStyleListComputed = computed(() => {
      const startIndex = (currentPage.value - 1) * pageSize.value;
      const endIndex = Math.min(startIndex + pageSize.value, tabStyleList && tabStyleList.length || 0);
      // 假设data是所有数据的数组
      return tabStyleList.slice(startIndex, endIndex);
    })

    const tabList = computed(() => {
      let tabDataText = JSON.parse(props.cptDataForm.dataText)
      return tabDataText.options
    })

    const onChangeDirection = (value) => {

      if (value === 'row') {
        props.currentCpt.cptWidth = 500
        props.currentCpt.cptHeight = 40
        props.currentCpt.cptOption.attribute.rowMarginBottom = 0
        props.currentCpt.cptOption.attribute.rowMarginTop = 0
      } else if (value === 'column') {
        props.currentCpt.cptWidth = 100
        props.currentCpt.cptHeight = 300
        props.currentCpt.cptOption.attribute.rowMarginLeft = 0
        props.currentCpt.cptOption.attribute.rowMarginRight = 0
      }
    }
    const onActionModal = () => {
      modalShow.value = !modalShow.value
    }
    const onActionJsonModal = () => {
      templateJSONShow.value = !templateJSONShow.value
      if (typeof props.attribute.tabStyleIndex === 'number') {
        jsonText.value = JSON.stringify(tabStyleList[props.attribute.tabStyleIndex]?.components, null, 2)
      } else {
        jsonText.value = ''
      }
      console.log(props.cacheComponents, 'qdwikjwqduq');
    }
    const onJSONConfirm = () => {
      let index = props.attribute.tabStyleIndex
      let json = jsonEditor.value.getValue()
      let tabId = props.currentCpt.id
      store.setTabStyleItemCompsJson(index, JSON.parse(json))
      clearTemplateComps()
      props.refMap[tabId].createGroupComponents(tabStyleIndex.value)

      onActionJsonModal()
    }
    const onSelectStyle = (index) => {
      tabStyleIndex.value = tabStyleIndex.value == index ? null : index
    }
    const onCancel = () => {
      tabStyleIndex.value = null
    }
    const onChangePage = (value) => {
      currentPage.value = value.current
    }
    const initTabData = () => {
      let tabDataJson = localStorage.getItem('copyTabLocalStorage')
      if (!tabDataJson) {
        return
      }
      let tabData = JSON.parse(tabDataJson)
      let currentIndex = props.cacheComponents.findIndex(({ id }) => id === props.currentCpt.id)

      props.cacheComponents[currentIndex] = tabData
    }
    const confirmCheck = async () => {
      modalShow.value = false

      await clearTemplateComps()

      props.attribute.tabStyleIndex = tabStyleIndex.value

      // 会导致只执行一次
      if (typeof props.attribute.tabStyleIndex != 'number') {
        console.log('选项卡: 初始化模版 init')
        await clearTemplateComps()

        props.currentCpt.cptOption.attribute = cptTabOption.attribute
        return false
      }

      let currentTab = props.refMap[props.currentCpt.id]
      if (!currentTab) {
        return
      }
      currentTab.createGroupComponents()

    }
    const clearTemplateComps = () => {
      console.log(props.refMap[props.currentCpt.id])
      let currentTab = props.refMap[props.currentCpt.id]
      if (!currentTab) {
        return
      }
      currentTab.clearTemplateComps()
    }



    onMounted(() => {
      let tabDataText = JSON.parse(props.cptDataForm.dataText)
      // tabList = tabDataText.options
      if (!props.attribute.tabDefaultKey) {
        props.attribute.tabDefaultKey = tabList.value[0].value
      }
      console.log(props.attribute.tabDefaultKey, 'props.attribute.tabDefaultKey')

      tabStyleIndex.value = props.attribute.tabStyleIndex
    })
    return {
      tabList,
      modalShow,
      tabStyleList,
      tabStyleIndex,
      currentPage,
      pageSize,
      tabStyleListComputed,
      templateText,
      templateJSONShow,
      jsonText,
      jsonEditor,
      isSelectTempJsonComputed,
      textFamilyList,
      templateRadioComputed,

      onCancel,
      confirmCheck,
      onChangePage,
      onSelectStyle,
      onChangeDirection,
      onActionModal,
      onChangePage,
      onActionJsonModal,
      onJSONConfirm
    }
  },

}
</script>

<style scoped>
.cpt-tab-option-dialog .tdesign-demo-image-viewer__ui-image {
  width: 100%;
  height: 100%;
  display: inline-flex;
  position: relative;
  justify-content: center;
  align-items: center;
  border-radius: var(--td-radius-small);
  overflow: hidden;
}

.cpt-tab-option-dialog .tdesign-demo-image-viewer__ui-image--hover {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.6);
  color: var(--td-text-color-anti);
  line-height: 22px;
  transition: 0.2s;
}

.cpt-tab-option-dialog .tdesign-demo-image-viewer__ui-image:hover .tdesign-demo-image-viewer__ui-image--hover {
  opacity: 1;
  cursor: pointer;
}

.cpt-tab-option-dialog .tdesign-demo-image-viewer__ui-image--img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  cursor: pointer;
  position: absolute;
}

.cpt-tab-option-dialog .tdesign-demo-image-viewer__ui-image--footer {
  padding: 0 16px;
  height: 56px;
  width: 100%;
  line-height: 56px;
  font-size: 16px;
  position: absolute;
  bottom: 0;
  color: var(--td-text-color-anti);
  background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
  display: flex;
  box-sizing: border-box;
}

.cpt-tab-option-dialog .tdesign-demo-image-viewer__ui-image--title {
  flex: 1;
}

.tab-option-color-wrap {
  display: flex;
  flex-direction: column;

}

.tab-option-color-wrap .tab-option-select {
  padding-bottom: 10px;
}

.cpt-tab-option-dialog .tdesign-demo-popup__reference {
  margin-left: 16px;
}

.cpt-tab-option-dialog .tdesign-demo-image-viewer__ui-image--icons .tdesign-demo-icon {
  cursor: pointer;
}

.cpt-tab-option-dialog .tdesign-demo-image-viewer__base {
  width: 160px;
  height: 160px;
  margin: 10px;
  border: 4px solid var(--td-bg-color-secondarycontainer);
  border-radius: var(--td-radius-medium);
}

.cpt-tab-option-dialog .list {
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  min-height: 480px;
  align-content: baseline;
}

.cpt-tab-option-dialog .list .list-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* width: 200px;
  height: 200px; */
  cursor: pointer;
  margin: 0 38px;
  border: 1px solid transparent;
  transition: .3s ease-in-out;
  padding: 5px;
  margin-bottom: 45px;
  margin-top: 10px;
  width: 180px;
}


.cpt-tab-option-dialog .list .active {
  border: 1px solid rgb(38, 132, 255);
  border-radius: 6px;
}

.cpt-tab-option-dialog .list .active p {
  color: rgb(38, 132, 255) !important;
}

.cpt-tab-option-dialog .list .list-item:hover {
  border: 1px solid rgb(38, 132, 255);
  border-radius: 6px;
  /* transform: translateY(-3px); */
  transform: scale(1.1);
}

.cpt-tab-option-dialog .list .list-item:hover p {
  color: rgb(38, 132, 255);
}

.cpt-tab-option-dialog .list .list-item .cover-img {
  width: 180px;
  height: 80px;
}

.cpt-tab-option-dialog .list .list-item .cover-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.cpt-tab-option-dialog .list .list-item p {
  font-size: 14px;
  color: #fff;
  transition: .3s ease-in-out;
  width: 100%;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
}
</style>
